import { render } from "./WithMetaInfo.vue?vue&type=template&id=18415c27&bindings={\"changeTab\":\"options\"}"
import script from "./WithMetaInfo.vue?vue&type=script&lang=js"
export * from "./WithMetaInfo.vue?vue&type=script&lang=js"
script.render = render

export default script